var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"addInvoice-con"},[_c('div',{staticClass:"addInvoice-main"},[_c('div',{staticClass:"addInvoice-title"},[_vm._v(" "+_vm._s(_vm.popupTitle)+" "),_c('img',{staticClass:"popup-close",attrs:{"src":"https://resource.rcclchina.com.cn/invoice/popupClose-icon.png","alt":""},on:{"click":_vm.closePopup}})]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }